module.exports = __webpack_public_path__ + "img/jht-icon-14.d7ebdf93.png";